import request from "../utils/request"

export function getCategoryList (data) {
	return request({
		url: '/category/index',
		method: 'get',
		data
	})
}

export function getCategory (data) {
	return request({
		url: '/category/detail',
		method: 'get',
		data
	})
}

export function getCategoryPriceList (data) {
	return request({
		url: '/category/priceList',
		method: 'get',
		data
	})
}
